<template>
  <section class="company">
    <div class="left-back">
      <img class="left-back-image" src="../../assets/img/left-back.png"/>
    </div>
    <div class="content">
      <img v-show="imgShow" class="left-img animated slideInUp" src="../../assets/img/company.png"/>
      <div class="introduction">
        <h2 class="subtitle">平台优势</h2>
        <p class="detailed">
          <span class="introduction-text">
          1）数据一体化边缘网关：边缘计算网关拥有强大的边缘计算能力，在变电站边缘节点实现多协议数据采集、多种智能设备接入、事件实时响应、数据标准化传输等功能；减少设备端与云端的接入难度。
          </span>
          <span class="introduction-text">
          边云协同，实现对变电站的设备、环境、视频等进行一体化安全监控，助力变电站设备快速上云、远程管理维护，提高变电站设备的数据完整性和实时性。
          </span>
          <span class="introduction-text">
            2）GIS实时定位：采用GIS技术，实时同步时钟，并通过地图直观呈现巡检人员的实时和历史巡检轨迹；智能识别安全隐患，突发状况北斗紧急通讯；实现电力运维精细化、科学化和安全性管控。
          </span>
          <span class="introduction-text">
            3）数据安全性保障：除常规安全硬件保障外，平台通过网络加密、数据加密、用户认证、服务溶断、降级、限流、ACL策略等多种技术全面保障系统的网络及数据安全。
          </span>
          <span class="introduction-text">
            4）轻量化组态：电力接线图和配电房图支持WEB在线协同组态，不需要插件支持，图形矢量化存储和展示，页面加载时间短，实现轻量化管理和使用。
          </span>
          <span class="introduction-text">
            5）高并发低时延：云平台支持分布式部署，可以满足更多用户同时在线访问；电力设备数据毫秒级响应，实时在线监测，全面提升用户体验和监测能力。
          </span>
          <span class="introduction-text">
            6）多平台整合的应用：采用B/S架构，用户无需安装客户端即可通过WEB浏览器访问；同时支持在APP或小程序访问，通过简单操作，实现电力监控、视频监控、设备管理、运行管理等多个模块的数据共享和联动。
          </span>
        </p>
        <!-- <button class="more">了解更多</button> -->
      </div>
    </div>
    <div class="right-back">
      <img class="right-back-image" src="../../assets/img/right-back.png"/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'company',
  data() {
    return {
      imgShow: false
    }
  },
  methods: {
    onScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if (top >= 580) {
        this.imgShow = true
      } else {
        this.imgShow = false
      }
    }
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>

.company {
  width: 100%;
  background-color: #0f054b;
  color: #edd8f5;
  padding: 30px 0;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.content {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  .introduction-text {
    display: block;
  }

  @media (max-width: 576px) {
    display: inline;

    .left-img {
      width: 100%;
      padding: 0 10%;
      flex: 1;
    }
    
    .introduction {
      padding: 0 15px;
      flex: 1;
      text-align: center;

      .detailed {
        text-align: left;
        text-indent: 25px;

        .introduction-text {
          display: block;
          // text-indent: 25px;
          text-indent: 0 !important;
        }
      }
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    max-width: 550px;

    .left-img{
      display: none;
    }
    .introduction-text {
      text-indent: 25px;
    }
    .subtitle {
      text-align: center;
    }
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .left-img{
      // width: 400px;
      display: none;
    }
    .introduction-text {
      text-indent: 25px;
    }
  }
  // ipad
  @media (width: 768px) and (height: 1024px) {
    padding: 0 30px;
    .left-img{
      display: none;
    }
    .subtitle {
      text-align: center;
    }
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.left-img {
  width: 120px;
  padding: 0 15px;
  flex: 1;
}

.introduction {
  padding: 0 15px;
  flex: 1;
  text-align: left;

  .subtitle {
    margin: 0;
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;
  }

  .detailed {
    font-size: 13px;
    line-height: 1.9;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .more {
    background-color: #e36cd9;
    box-shadow: 0 13px 27px 0 rgba(244, 134, 101, 0.25);
    color: #ffffff;
    border: none;
    padding: 12px 36px;
    position: relative;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 600;
    font-size: 13px;
  }
}

.left-back {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  .left-back-image {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    border-style: none;
  }
}

.right-back {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;

  .right-back-image  {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    border-style: none;
  }
}
</style>